module.exports = __webpack_public_path__ + "img/landing_photo.a572fccb.jpg";